import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { filter, firstValueFrom } from 'rxjs';
import { UserInfo } from '../models/common';
import { FEATURES } from '../consts/app-constants';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class CampaignGuard {
    constructor(
        private commonService: CommonService,
        private router: Router
    ) { }

  async canActivate(): Promise<boolean> {
    try {
      const userInfo: UserInfo = await firstValueFrom(
        this.commonService.getUserInfoValue()!
          .pipe(filter((user): user is UserInfo => user !== null))
      );

      const isCampaignEnabled =
        userInfo.featureIds?.includes(FEATURES.CampaignFeatureName) ?? false;

      if (isCampaignEnabled || userInfo.isSaasUser) {
        return true;
      }

      this.router.navigate(['/dashboard']);
      return false;

    } catch (error) {
      console.error('Failed to get features:', error);
      this.router.navigate(['/dashboard']);
      return false;
    }
  }
}
